import React, { useState } from 'react';
import { Box, Button, Stack, Typography, Paper } from '@mui/material';
import LandingPageNav from '../../components/landingpage/LandingPageNav';
import MortgageCalculator from '../../components/calculator/Calculator';
import RefinanceCalculator from '../../components/calculator/refinanceCalculator';
import Footer from '../../components/Footer/footer';
import MortgageCalculatorModern from '../../components/calculator/MortgageCalculatorModern';



const CalculatorDashboard = () => {
  const [selectedCalculator, setSelectedCalculator] = useState('purchase');

  return (
    <>
    <Box className="mc-no-print"><LandingPageNav /></Box>
    <Box
  sx={{
    p: 4,
    pt: { xs: 12, md: 14 },   // ✅ adds space under the navbar
    backgroundColor: '#f9f9f9',
    minHeight: '100vh',
    '@media print': {
      p: 0,
      pt: 0,
      minHeight: 'auto',
      backgroundColor: '#fff',
    },
  }}
>
      {/* <Typography variant="h4" align="center" sx={{ mb: 4, fontWeight: 'bold' }}>
        Mortgage Calculators
      </Typography>

      <Typography variant="body1" align="center" sx={{ mb: 4, color: '#555' }}>
        Use the buttons below to switch between Purchase and Refinance calculators.
      </Typography>

      <Stack direction="row" justifyContent="center" spacing={2} mb={4}>
        <Button
          variant={selectedCalculator === 'purchase' ? 'contained' : 'outlined'}
          onClick={() => setSelectedCalculator('purchase')}
          sx={{ minWidth: 180 }}
        >
          Purchase Calculator
        </Button>
        <Button
          variant={selectedCalculator === 'refinance' ? 'contained' : 'outlined'}
          onClick={() => setSelectedCalculator('refinance')}
          sx={{ minWidth: 180 }}
        >
          Refinance Calculator
        </Button>
      </Stack> */}

     <Paper sx={{ maxWidth: 1500, mx: 'auto', p: { xs: 3, md: 5 }, '@media print': { p: 0, boxShadow: 'none' } }}>
  <MortgageCalculatorModern logoSrc='/favicon/JET_singleline_color.jpg' />

  {/* CTA Section */}
  <Box
    className="mc-no-print"
    sx={{
      mt: 6,
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 2,
    }}
  >
    <Typography
      sx={{
        fontWeight: 900,
        fontSize: { xs: 20, md: 26 },
      }}
    >
      Want a personalized quote?
    </Typography>

    <Typography
      sx={{
        fontSize: { xs: 14, md: 18 },
        maxWidth: 600,
        opacity: 0.8,
      }}
    >
      Talk to a Jet HomeLoans expert and get a scenario built specifically for your goals.
    </Typography>

    <Button
      variant="contained"
      size="large"
      sx={{
        fontWeight: 900,
        px: 5,
        py: 1.5,
        fontSize: 16,
        borderRadius: 2,
      }}
      onClick={() => {
        window.location.href = '/find-a-loan-officer';
      }}
    >
      Get Started
    </Button>
  </Box>
</Paper>
    </Box>
    <Box className="mc-no-print"><Footer /></Box>
    </>
  );
};

export default CalculatorDashboard;
